import {NgModule} from '@angular/core';
import {Routes, RouterModule, PreloadAllModules} from '@angular/router';
import {PageNotFoundComponent} from './modules/shared/error_pages/page-not-found/page-not-found.component';
import {AccessDeniedComponent} from './modules/shared/error_pages/access-denied/access-denied.component';
import {SiteLayoutComponent} from './modules/web/layout/site-layout/site-layout.component';
import {AppLayoutComponent} from './modules/shared/layouts/app-layout/app-layout.component';

import {UserNotificationComponent} from './modules/shared/ui/user-notification/user-notification.component';


// @ts-ignore
const routes: Routes = [


    {
        path: 'common',

        children: [
            {path: 'agent-notifications', component: UserNotificationComponent},
             {path: 'access_denied', component: AccessDeniedComponent},
            {path: 'pageNotFound', component: PageNotFoundComponent}
        ]
    },

    {
        path: 'admin',
        loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule)
    },

    {
        path: '',
        loadChildren: () => import('./modules/web/web.module').then(m => m.WebModule)
    },


    {
        path: '',
        component: AppLayoutComponent,
        children: [
            {path: 'access_denied', component: AccessDeniedComponent},
            {path: 'pageNotFound', component: PageNotFoundComponent}
        ]
    },

];

@NgModule({
    imports: [RouterModule.forRoot(routes,
        {
            scrollPositionRestoration: 'enabled',
            // preloadingStrategy: PreloadAllModules,
            relativeLinkResolution: 'legacy'
        })],
    exports: [RouterModule]
})


export class AppRoutingModule {
}
